import { render, staticRenderFns } from "./Configurar.vue?vue&type=template&id=4ee358fc&"
import script from "./Configurar.vue?vue&type=script&lang=js&"
export * from "./Configurar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports